import PropTypes from 'prop-types';
import { toAudString } from 'utils/currency';

export const Fees = ({
  items
}) => items.map((fee) => (
  <div key={fee.ItemID}>
    <div className="cart-total-wrap cart-delv-total">
      <div className="row visible-xs">
        <div className="col-xs-8">
          <div className="row-heading">&nbsp;</div>
        </div>
        <div className="col-xs-4 text-right">
          <div className="row-heading">Price</div>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-8">
          <strong>{fee.Description}</strong>
        </div>
        <div className="col-xs-4 text-right">{toAudString(fee.Amount)}</div>
      </div>
    </div>
  </div>
));

Fees.propTypes = {
    items: PropTypes.array.isRequired,
};
